export default "__VITE_ASSET__Q_1fUVl9__"